import { render, staticRenderFns } from "./DocumentDialogForm.vue?vue&type=template&id=1c9bea45"
import script from "./DocumentDialogForm.vue?vue&type=script&lang=js"
export * from "./DocumentDialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports